
import {Component, Vue, Watch} from "vue-property-decorator";
import {TakipAltTipiEntity} from "@/entity/TakipAltTipiEntity";
import TakipAltTipAlanlarList from "@/components/lists/TakipAltTipAlanlarList.vue";
import TakipAltTipInfo from "@/components/infos/TakipAltTipInfo.vue";
import TahsilatDusmeSirasi from "@/components/TahsilatDusmeSirasi.vue";
import {TakipAltTipHesapAyarEntity} from "@/entity/TakipAltTipHesapAyarEntity";
import {TakipTipi} from "@/enum/TakipTipi";
import TercihlerIlamBilgileri from "@/components/TercihlerIlamBilgileri.vue";

@Component({
  computed: {
    TakipTipi() {
      return TakipTipi
    }
  },
  components: {
    TercihlerIlamBilgileri,
    TahsilatDusmeSirasi,
    TakipAltTipAlanlarList,
    TakipAltTipInfo,
  },
})
export default class TakipAltTipView extends Vue {
  item: TakipAltTipiEntity = new TakipAltTipiEntity();
  TakipTipi = TakipTipi
  mounted() {
    this.load();
  }

  changeBorcMetin(){
    if (this.item.borc_metni_var_mi){
      this.item.takip_talebi_metni = "(Toplam Alacak Tutarı) tutarındaki toplam alacağın icra gideri, vekalet.ücreti ve takip tarihinden itibaren asıl alacağa işleyecek ( {{faizAciklamasi}}) faiz ile tahsili talebidir. (Fazlaya dair ve faiz oranlarındaki artıştan doğan talep hakkımız saklıdır) TBK. 100.mad. gereğince kısmi ödemeler öncelikle işlemiş faiz, masraf ve fer’ilere mahsup edilecektir. Borcunuzu itiraz süresi içerisinde öderseniz: Takip Toplamı: ({{takipToplami}}) + Vekalet Ücreti: ({{vekaletUcreti}}) + Harç : ({{harc}}) + Masraf : ({{masraf}}) = Toplam Borç : ({{toplam}}) + Takip Sonrası İşleyecek Faiz. Ödemeniz Gerekmektedir."
      this.$http.put(`/api/v1/takip-alt-tipi/${this.$route.params.id}`,this.item).then(()=>{
        this.load()
      })
    }else{
      this.item.takip_talebi_metni = "(Toplam Alacak Tutarı) tutarındaki toplam alacağın icra gideri, vekalet.ücreti ve takip tarihinden itibaren asıl alacağa işleyecek ( {{faizAciklamasi}}) faiz ile tahsili talebidir. (Fazlaya dair ve faiz oranlarındaki artıştan doğan talep hakkımız saklıdır) TBK. 100.mad. gereğince kısmi ödemeler öncelikle işlemiş faiz, masraf ve fer’ilere mahsup edilecektir."
      this.$http.put(`/api/v1/takip-alt-tipi/${this.$route.params.id}`,this.item).then(()=>{
        this.load()
      })
    }

  }

  load() {
    this.$http.get(`/api/v1/takip-alt-tipi-detay-list/${this.$route.params.id}`).then((response) => {
      this.item = response.data;
      this.item.takip_alt_tip_hesap_ayar.sort((prev: TakipAltTipHesapAyarEntity, current: TakipAltTipHesapAyarEntity) => (prev.gosterim_sirasi - current.gosterim_sirasi));
    });
  }
}
